import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const AppAuthManagedByField = ({ field, form, options, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const error =
        form.errors.defaultManagedBy && form.touched.defaultManagedBy
            ? form.errors.defaultManagedBy
            : '';
    const managedByOptions = (options || []).map((option) => ({
        id: option.value,
        name: option.name,
    }));

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Default Managed By{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the default management type for users.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <DropDown
                                field={field}
                                form={form}
                                name="defaultManagedBy"
                                data={managedByOptions}
                                shownValue="name"
                                placeholder="Select managed by option"
                                darkMode={darkMode}
                                width="100%"
                                noPadding
                                handleSelectChange={(item) =>
                                    form.setFieldValue(
                                        'defaultManagedBy',
                                        item?.id ?? '',
                                    )
                                }
                            />

                            <Text
                                color="red.500"
                                fontSize="xs"
                                mt={1}
                                textAlign="right">
                                {error}
                            </Text>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select how users will be managed by default"
                        ariaLabel="managed-by-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AppAuthManagedByField;
